import { render, staticRenderFns } from "./SummaryToday.vue?vue&type=template&id=08bfd1db&scoped=true&"
import script from "./SummaryToday.vue?vue&type=script&lang=js&"
export * from "./SummaryToday.vue?vue&type=script&lang=js&"
import style0 from "./SummaryToday.vue?vue&type=style&index=0&id=08bfd1db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfd1db",
  null
  
)

export default component.exports